import {
  SET_SPAAZA_USER,
  CLEAR_SPAAZA_USER,
  SET_SPAAZA_WALLET
} from '@/utils/store/mutationTypes'

export default {
  [SET_SPAAZA_USER] (state, { referralCode }) {
    state.referralCode = referralCode
  },
  [SET_SPAAZA_WALLET] (state, { amount, currency }) {
    state.amount = amount
    state.currency = currency
  },
  [CLEAR_SPAAZA_USER] (state) {
    state.referralCode = ''
  }
}
